import { render, staticRenderFns } from "./MobileListFavouriteItems.vue?vue&type=template&id=162d642d&scoped=true"
import script from "./MobileListFavouriteItems.vue?vue&type=script&lang=js"
export * from "./MobileListFavouriteItems.vue?vue&type=script&lang=js"
import style0 from "./MobileListFavouriteItems.vue?vue&type=style&index=0&id=162d642d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162d642d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162d642d')) {
      api.createRecord('162d642d', component.options)
    } else {
      api.reload('162d642d', component.options)
    }
    module.hot.accept("./MobileListFavouriteItems.vue?vue&type=template&id=162d642d&scoped=true", function () {
      api.rerender('162d642d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MobileListFavouriteItems.vue"
export default component.exports